import { Box, Flex } from '@chakra-ui/react';
import { NavBar } from '../features/header/NavBar.tsx';
import { useLayoutStore } from '../stores/layoutStore.ts';
import { Outlet } from 'react-router-dom';

export const ScrollLayout = () => {
  const layoutStore = useLayoutStore();

  return (
    <Flex flexDir={'column'} paddingBottom={'10px'} height={'100vh'}>
      <NavBar />
      <Box width={'100%'} p={1} flexGrow={1} maxH={'calc(100vh - 100px)'}>
        <Outlet />
      </Box>

      {layoutStore.isDataDisplayOpen && <Box paddingBottom={'35vh'}></Box>}
      {layoutStore.isExpanderRendered && <Box paddingBottom={'35px'}></Box>}
    </Flex>
  );
};
